import { render } from "./BlogDetailView.vue?vue&type=template&id=38348d8b&scoped=true"
import script from "./BlogDetailView.vue?vue&type=script&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&lang=js"

import "./BlogDetailView.vue?vue&type=style&index=0&id=38348d8b&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38348d8b"]])

export default __exports__